export const UnauthorizedContainer = () => {
    return (
      <div role={'note'}>
        {'You are not authorized to view this page.'}
      </div>
    );
};